export const mainColor = "#8c11be"
export const mainColorLight = "#a679b8"
export const mainColorButton = "#a328d6"
export const mainContrastColor = "white"

export const textPrimaryColor = "black"
export const textSecondaryColor = "#c6c6c6"
export const negativeColor = "red"
export const positiveColor = "green"